import styled from 'styled-components';
import {
  Radio as SemanticRadio,
} from 'semantic-ui-react';

import { Text as TextLayout } from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../layout-components/search';

const Container = styled.div``;

const ContainerInputSearch = styled.div`
  padding: 20px 0;
`;

const InputSearch = styled(SearchLayoutComponent).attrs({
  width: '100%',
})``;

const ContainerContent = styled.div`
`;

const ContainerScroll = styled.div`
  height: 200px;
  overflow-y: auto;
  border: 1px solid #DEDEDF;
  padding-top: 10px;
`;

const TextPrimary = styled(TextLayout)`
  padding-left: 30px;
`;

const TextPrimaryBold = styled(TextLayout.Bold)`
  padding-left: 14px;
`;

const Radio = styled(SemanticRadio)``;

const ContainerRadio = styled.div`
  padding: 2px 0 2px 24px;
`;

const ContainerLink = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LinkManageFolders = styled.a``;

const Text = styled(TextLayout)`
  font-size: 18px;
  color: ${({ theme }) => theme.color.textTitle};
  margin-right: 12px;
`;

export {
  Container,
  InputSearch,
  ContainerInputSearch,
  ContainerContent,
  ContainerScroll,
  TextPrimary,
  TextPrimaryBold,
  Radio,
  ContainerRadio,
  ContainerLink,
  LinkManageFolders,
  Text,
};
